import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { Icon } from "../../common/icons"
import { BsFillReplyFill } from "react-icons/bs"
import { ChatStyles } from "./index"

interface ChatReplyIconProps {
  id: string
  isMobile: boolean
  isShowReplyIcon: boolean
  handleReply: (id: string, isReply?: boolean) => void
  isReply?: boolean
  styleschat: ChatStyles
}

const _ChatReplyIcon: React.FC<ChatReplyIconProps> = ({
  isMobile,
  isShowReplyIcon,
  handleReply,
  id,
  isReply,
  styleschat
}) => {
  const handleChatReply = React.useCallback(
    e => {
      handleReply(id, isReply)
      e.preventDefault()
      e.stopPropagation()
    },
    [id, isReply, handleReply]
  )

  return (
    <>
      {isShowReplyIcon && (
        <Flex
          marginLeft="auto"
          alignItems="end"
          height={"100%"}
          zIndex={!isMobile && 10000000}
        >
          <Icon
            src={BsFillReplyFill}
            marginLeft="0.1rem"
            fontSize={isMobile && "1.15em"}
            onClick={handleChatReply}
            cursor={"pointer"}
            opacity={0.75}
            color={styleschat?.servicePanelElementPrimaryText ?? "#A0AEC0"}
            _hover={!isMobile && { opacity: 1 }}
          />
        </Flex>
      )}
    </>
  )
}

export const ChatReplyIcon = React.memo(_ChatReplyIcon)
